import React, { Component } from "react";
import GLOBALS from '../utils/Constants';
import CryptoJS from 'crypto-js'
import moment from 'moment-timezone';


export default class UsersService {

    static sharedInstance = UsersService.sharedInstance == null ? new UsersService() : this.sharedInstance;

    constructor() {
       // this.checkIfTokenIsValid();

       this.user_types = {
            'Administrator':'Administrator',
            'Supervisor':'Supervisor',
            'Employee':'Employee',
            'Client':'Client',
            'hr_commander_user':'HR Commander User',
            'hr_commander_admin':'HR Commander Admin',
            'Auditor':'Auditor',
            'Super':'Archon'
        };

        this.user_types_upload = {
            'Administrator':'Administrator',
            'Supervisor':'Supervisor',
            'Employee':'Employee',
            'Client':'Client',
            'HR Commander User':'hr_commander_user',
            'HR Commander Admin':'hr_commander_admin',
            'Auditor':'Auditor',
            'Archon':'Super'
        }

        this.credentials = this.getStoredCredentials();
        this.auth_username = this.credentials.username;
        this.license = this.credentials.license;
        this.token = this.credentials.token;
    }

    getUpdatedCrendetials(){
        this.credentials =  this.getStoredCredentials();
        this.auth_username = this.credentials.username;
        this.license = this.credentials.license;
        this.token = this.credentials.token;
    }


    checkIfTokenIsValid(params){
        //check response in api call if has token errors
        if(typeof(params) != "undefined"){
            try{
                if(params.success == 0 && params.code_error == "invalid_token"){
                    //alert("Your session has expired. Please login again.")
                    this.logout();
                    window.location.reload();
                    return false;
                }
            }
            catch(e){

            }
        }
    }

    storeLoggedInCredentials(recno, username, license, tokenData, rememberMe, password, loginResponse){

        const encryptedUserRecno = CryptoJS.AES.encrypt(recno, GLOBALS.CRYPTO_SECRET);
        const encryptedUsername = CryptoJS.AES.encrypt(username, GLOBALS.CRYPTO_SECRET);
        const encryptedLicense = CryptoJS.AES.encrypt(license, GLOBALS.CRYPTO_SECRET);
        const encryptedPassword = CryptoJS.AES.encrypt(password, GLOBALS.CRYPTO_SECRET);
        const encryptedToken = CryptoJS.AES.encrypt(tokenData.token, GLOBALS.CRYPTO_SECRET);
        const encryptedLoginResponse = CryptoJS.AES.encrypt(JSON.stringify(loginResponse), GLOBALS.CRYPTO_SECRET); //do not encrypt token, decryption issues
        const encryptedPermissionInfo = CryptoJS.AES.encrypt(JSON.stringify(loginResponse.permission_info), GLOBALS.CRYPTO_SECRET); //do not encrypt token, decryption issues

        localStorage.setItem("recno", encryptedUserRecno);
        localStorage.setItem("username", encryptedUsername);
        localStorage.setItem("license", encryptedLicense);
        localStorage.setItem("password", encryptedPassword);

        localStorage.setItem("token", encryptedToken);

        localStorage.setItem("loggedIn", true);
        localStorage.setItem("tokenExpirationDate", tokenData.expiration_date);
        localStorage.setItem("rememberMe", rememberMe);

        localStorage.setItem("loginResponse", encryptedLoginResponse);
        localStorage.setItem("onDuty", this.returnEmptyIfNull(loginResponse.data[0].on_duty));
        localStorage.setItem("permissionInfo", encryptedPermissionInfo);
        //console.log(JSON.stringify(loginResponse));

    }

    getDecryptedData(variableName){
        try{
            const encryptedData = localStorage.getItem(variableName);
            if(encryptedData){
                const bytes = CryptoJS.AES.decrypt(encryptedData.toString(), GLOBALS.CRYPTO_SECRET);
                //console.log(encryptedData.toString(), bytes.toString(CryptoJS.enc.Utf8));
                if(variableName == "loginResponse" || variableName == "permissionInfo" ){
                     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                }
                return bytes.toString(CryptoJS.enc.Utf8);
            }
            else{
                return encryptedData;
            }
        }
        catch(e){
            return "malformed data";
        }

    }

    getStoredCredentials(){
        const recnoLoggedIn = this.getDecryptedData("recno");
        const usernameLoggedIn = this.getDecryptedData("username");
        const licenseLoggedIn = this.getDecryptedData("license");
        const tokenLoggedIn = this.getDecryptedData("token");
        const passwordLoggedIn = this.getDecryptedData("password");
        const tokenExpirationDate = localStorage.getItem("tokenExpirationDate");
        const rememberMe = localStorage.getItem("rememberMe");
        const loginResponse = this.getDecryptedData("loginResponse");

        const onDuty = localStorage.getItem("onDuty");
        const permissionInfo = this.getDecryptedData("permissionInfo");

        return ({recno: recnoLoggedIn, username: usernameLoggedIn, license: licenseLoggedIn, token: tokenLoggedIn, rememberMe: rememberMe, tokenExpirationDate: tokenExpirationDate, password: passwordLoggedIn, loginResponse: loginResponse, permissionInfo: permissionInfo, onDuty: onDuty});
    }

    logout(){
        const rememberMe = this.getRememberMeValue();
        if(!rememberMe){
            localStorage.setItem("username", null);
            localStorage.setItem("license", null);
            localStorage.setItem("password", null);
        }
        localStorage.setItem("token", null);
        localStorage.setItem("tokenExpirationDate", null);
        localStorage.setItem("loggedIn", false);
        localStorage.setItem("loginResponse", null);
        localStorage.setItem("recno", null);
        localStorage.setItem("permissionInfo", null);
    }

    getRememberMeValue(){
        const savedRememberMe = localStorage.getItem("rememberMe");
        const rememberMe = savedRememberMe ?  localStorage.getItem("rememberMe") : false;
        return rememberMe === 'true' || rememberMe === 'on' ? true : false;
    }

    urlEncodeParams(params){
        let formBody = [];
        for (let property in params) {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(params[property]);
            if(encodedValue == "undefined" || !encodedValue || encodedValue == null){
                encodedValue="";
            }
            formBody.push(encodedKey + "=" + encodedValue);
        }

        formBody = formBody.join("&");
        return formBody;
    }

    returnEmptyIfNull(value){
        const tempValue  = value == "undefined" || !value || value==null ? "" : value;
        return tempValue;
    }

    getUserType(type){
        const user_types = this.user_types;

        if(type && user_types[type]){
            return user_types[type];
        }

        return '';
    }

    getUserTypeToUpload(type){
        const user_types = this.user_types_upload;

        if(user_types[type]){
            return user_types[type];
        }else{
            return 'Employee';
        }
    }

    getUserTypeOptions(action = 'add'){
        const login = this.getDecryptedData("loginResponse");
        const {data} = login;
        const type = data[0].User_Type;

        const options = [];
        const user_types = this.user_types;
        const keys = Object.keys(user_types);

        for(let x = 0; x < (keys).length; x++){
            const key = keys[x];
            const value = user_types[key];

            if(key === 'Super'){
                if(type === 'Super'){
                    options.push(<option value={key} key={key}>{value}</option>)
                }else{
                    if(action === 'edit'){
                        options.push(<option value={key} key={key} disabled>{value}</option>)
                    }
                }
            }else{
                options.push(<option value={key} key={key}>{value}</option>)
            }
        }

        return options;
    }

    /*** API Calls ***/
    async signInWithCredentials(license, username, password){

        const params = {
            "auth_username": username,
            "password": password,
            "license": license,
        }

        const formBody = this.urlEncodeParams(params);
        const response = await fetch(GLOBALS.LOGIN_API, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            return responseJson;
        } catch (error) {
            console.error("Login error", error);
        }
    }

    async fetchUsers(license, username, token, is_active){
        const params = {
            "license": license,
            "auth_username": username,
            "token": token,
            "is_active": is_active
        }

        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.GET_USERS_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("Fetch users error", error);
        }
    }

    async add_user(params){

        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.ADD_USER_API, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("add user error", error);
        }
    }

    async getUserInfo(license, username, id, token){
        const params = {
            "license": license,
            "id": id,
            "auth_username": username,
            "token": token
        }

        const formBody = this.urlEncodeParams(params);
        const response = await fetch(GLOBALS.GET_USER_API+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });
        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("get user info error", error);
        }
    }

    async update_user(params){
        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.EDIT_USER_API, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();

        try {

            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("update_user error",error);
        }
    }

    async update_user_status(params){

        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.UPDATE_USER_STATUS_API, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("Update user status error", error);
        }
    }

    async delete_user(params){

        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.DELETE_USER_API, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;

        } catch (error) {
            console.error("Delete user error", error);
        }
    }

    async getLitmosUserData(params){

        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_LITMOS_USER+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("E-learning get user data error", error);
        }
    }

    async uploadFormsToS3(params){

        const data = new FormData();

        data.append("file", params.file);
        data.append("auth_username", params.auth_username);
        data.append("token", params.token);
        data.append("sub_user_id", params.sub_user_id);
        data.append("license", params.license)
        data.append("client", params.client)
        data.append("branch_name", params.branch_name);
        data.append("branch_id", params.branch_id)
        data.append("facility_id", params.facility_id);
        data.append("facility_name", params.facility_name)
        data.append("client_id", params.client_id);
        data.append("client_name", params.client_name)

        const response = await fetch(GLOBALS.API_UPLOAD_FORM_TO_S3, {
            method: 'POST',
            body: data
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("upload to s3 error", error);
            alert("Error in uploading the file.");
        }
    }

    async getAllFormsByLicense(params){

        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_ALL_FORMS_BY_LICENSE+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("Get forms by license error", error);
        }
    }

    async getFormDataByType(params){
        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_FORM_DATA_BY_TYPE+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("get form data error", error);
        }
    }

    async saveFormData(params){
        const formBody = this.urlEncodeParams(params);
        const response = await fetch(GLOBALS.API_SAVE_FORM_DATA, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("save form data error", error);
        }
    }

    async getDropdownDataForAddForm(params){
        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_GET_DROPDOWN_DATA_FOR_ADD_FORM+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            }
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("get dropdown data for add form error" , error);
        }
    }

    async updateFormData(params){
        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_UPDATE_DROPDOWN_DATA, {
            method: 'PUT',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            return responseJson;
        } catch (error) {
            console.error("update form data", error);
        }
    }

    async deleteFormData(params){
        const formBody = this.urlEncodeParams(params);

        const response = await fetch(GLOBALS.API_DELETE_DROPDOWN_DATA, {
            method: 'DELETE',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });
        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("delete form data", error);
        }
    }

    async uploadUsers(params){
        const formBody = this.urlEncodeParams(params);


        const response = await fetch(GLOBALS.API_UPLOAD_USERS, {
            method: 'POST',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
            },
            body: formBody
        });

        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("upload users", error);
        }
    }
    /*** End of API Calls ***/

    async createFileFromURL(url){
      const response = await fetch(url);
      const data = await response.blob();
      return data;
    }

    async getUsersOnDuty(){

        this.getUpdatedCrendetials();

        const params = {
            "license": this.license,
            "auth_username": this.auth_username,
            "token":  this.token
        }

        const formBody = this.urlEncodeParams(params);
        const response = await fetch(GLOBALS.GET_USERS_ON_DUTY+"&"+formBody, {
            method: 'GET',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded'
            },
        });
        const responseJson = await response.json();
        try {
            this.checkIfTokenIsValid(responseJson);
            return responseJson;
        } catch (error) {
            console.error("get users on duty error", error);
        }
    }

}
